module.exports = __webpack_public_path__ + "img/az.e3c33647.svg";